const phoneNumber = () => {
	const phoneInput = document.querySelectorAll('.js-phone-number');

	phoneInput.forEach(input => {
		if (!input.dataset.watchingPhoneNumber) {
			input.dataset.watchingPhoneNumber = true;

			input.addEventListener('input', () => {
				input.value = phoneMask(input.value);
			});

			input.addEventListener('paste', () => {
				input.value = phoneMask(input.value);
			});
		}
	});

	const phoneMask = (phone) => {
		return phone.replace(/\D/g, '')
			.replace(/^(\d)/, '($1')
			.replace(/^(\(\d{5})(\d)/, '$1) $2')
			.replace(/(\d{6})(\d{1,5})/, '$1')
	}
};

phoneNumber();